import httpClient from 'utils/httpClient.js';

export const getListCdrs = (params = {}) => {
  return httpClient.get('/voip/cdrs', { params: { ...params, _t: Date.now() } });
};

export const getVoipRecording = (recordingUrl) => {
  return httpClient.get(recordingUrl, { responseType: 'blob' });
};

export const syncCdrs = (id, data = {}) => {
  return httpClient.post(`/voip/sync-cdrs/${id}`, data);
};

export const createNoteVoip = (data) => {
  return httpClient.post('/crm-note-phonenumber', data);
};

export const getListNoteVoip = (params) => {
  return httpClient.get('/crm-note-phonenumber', { params });
};

export const getTaskWithVoip = (params) => {
  return httpClient.get(`/task/voip`, { params });
};

export const getShiftInfo = () => {
  return httpClient.get(`/user/shift-info`);
};

export const getGrandstreamConfig = () => {
  return httpClient.get(`/voip/grandstream-config`, { params: { _t: Date.now() } });
};

export const getGrandstreamExtensionAssignments = (params = {}) => {
  return httpClient.get(`/voip/grandstream-extension-assignments`, { params });
};

export const assignGrandstreamExtension = (userId, data = {}) => {
  return httpClient.put(`/voip/grandstream-extension-assignments/${userId}`, data);
};

export const transferCall = (data) => {
  return httpClient.post(`/voip/transfer`, data);
};

export const recallUpdateVoip = (data) => {
  return httpClient.post(`/voip/recall-update`, data);
};

export const exportExcel = (params) => {
  return httpClient.post(`/voip/export-excel`, params, { responseType: `blob` });
};

export const getVoipExt = (params) => {
  return httpClient.get(`/voip/voip-ext`, { params });
};
